/**
 * I do not know what auth does here and how to auth as a user, so
 * I've created LoginUser. This should provide access to
 * this system through login form.
 *
 * Still remains to implement protected api requests
 */

import Cookies from "js-cookie";
import { api as apiLoginUser /*, apiHttps as apiLoginUserHttps*/ } from "@/gateways/loginUserApi";
import { api as apiService } from "@/gateways/unilabApi";

export default {
  // You can use it as state property
  state: {
    status: "",
    token: "", // token here
    userInfo: {},
    showTranslationsId: false,
    showEnglishToolTip: false
  },
  getters: {
    /* isLogged: state => {
      return (state.userInfo != null);
    }, */
    hideFlag: state => {
      if (state.userInfo != null) {
        return state.userInfo.hideFlag;
      }
      return false;
    },
    isUserLogged: state => state.userInfo != null,
    loggedUserInfo: state => state.userInfo,
    isLoggedUserAdmin: state => {
      if (state.userInfo != null) {
        if (state.userInfo.role != null) {
          return state.userInfo.role.toLowerCase() == "admin";
        }
      }
      return false;
    },
    isLoggedUserUnilab: state => {
      if (state.userInfo != null) {
        if (state.userInfo.role != null) {
          return state.userInfo.role.toLowerCase() == "unilab";
        }
      }
      return false;
    },
    bShowTranslationsId: state => state.showTranslationsId,
    bShowEnglishToolTip: state => state.showEnglishToolTip
  },
  mutations: {
    beforeLogin(state) {
      Cookies.remove("loginToken");
      state.status = "loading";
    },
    setToken(state, payload) {
      // save in store
      state.token = payload;
      state.status = "success";
      Cookies.remove("accessToken");
      // save in cookies
      Cookies.set("loginToken", payload, { expires: 30 });
    },
    setUserInfo(state, payload) {
      // save in store
      state.userInfo = payload;
    },
    clearToken(state) {
      state.token = "";
      state.status = "";
      state.userInfo = null;
      state.profiloUtente = null;
      Cookies.remove("loginToken");
    },
    bShowTranslationsId(state) {
      state.showTranslationsId = !state.showTranslationsId;
    },
    bShowEnglishToolTip(state) {
      state.showEnglishToolTip = !state.showEnglishToolTip;
    },
    setAppLanguage(state, language) {
      state.userInfo.appLanguage = language;
      apiService.get("account/setUserAppLanguage?lang=" + language);
    }
  },

  actions: {
    // this login user to access dashboard and all system.
    loginUser(ctx, payload) {
      return new Promise((resolve, reject) => {
        apiLoginUser
          .post("account/login", {
            email: payload.email,
            password: payload.password
          })
          .then(resp => {
            ctx.commit("setToken", resp.data);
            resolve(resp);
          })
          .catch(err => {
            console.warn("account/login err:::::", err, err.response);
            ctx.commit("clearToken");
            reject(err);
          });
      });
    },
    changeUserPassword(ctx, payload) {
      return new Promise((resolve, reject) => {
        apiLoginUser
          .post("account/changeUserPassword", {
            email: payload.email,
            oldPassword: payload.oldPassword,
            newPassword: payload.newPassword
          })
          .then(resp => {
            //ctx.commit("clearToken");
            resolve(resp.data);
          })
          .catch(err => {
            console.warn("account/changeUserPassword err:::::", err, err.response);
            ctx.commit("clearToken");
            reject(err);
          });
      });
    },

    getUserInfo(ctx) {
      return new Promise((resolve, reject) => {
        apiService
          .get("account/getUserInfo")
          .then(resp => {
            ctx.commit("setUserInfo", resp.data);
            resolve(resp);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    requestLoginAccess(ctx, payload) {
      return new Promise((resolve, reject) => {
        // apiLoginUserHttps
        apiLoginUser
          .post("account/getaccess", { email: payload.email })
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            console.warn("getaccess ERROR::", err, err.response);
            reject(err);
          });
      });
    },

    registerUser(ctx, payload) {
      return new Promise((resolve, reject) => {
        apiLoginUser
          .post("account/register", {
            email: payload.email,
            password: payload.password,
            confirmPassword: payload.confirmPassword,
            fullName: payload.fullName,
            companyName: payload.companyName
          })
          .then(resp => {
            resolve(resp);
          })
          .catch(err => {
            console.warn("register ERROR::", err, err.response);
            reject(err);
          });
      });
    },
    bShowTranslationsId({ commit }) {
      commit("bShowTranslationsId");
    },
    bShowEnglishToolTip({ commit }) {
      commit("bShowEnglishToolTip");
    }
  }
};
